import { useState, useEffect } from "react";
import Icon from "@/components/ui/Icon";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "Ana Sayfa", href: "/" },
  { label: "Hakkımızda", href: "/hakkimizda" },
  { label: "Hizmetler", href: "/hizmetler" },
  { label: "Referanslar", href: "/referanslar" },
  { label: "SSS", href: "/sss" },
  { label: "İletişim", href: "/iletisim" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => { setMenuOpen(false); }, [location.pathname]);

  const isHome = location.pathname === "/";
  const transparent = isHome && !scrolled;

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled || !isHome ? "bg-white/95 backdrop-blur-md border-b border-stone-100" : "bg-transparent"}`}>
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center shrink-0">
          <span className={`text-xl md:text-2xl font-extrabold tracking-tight leading-none ${scrolled || !isHome ? 'text-stone-900' : 'text-white'}`}>İzmir <span style={{ color: '#C9A34D' }}>Tenteci</span></span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`px-3 py-2 text-sm font-medium rounded-lg transition-all whitespace-nowrap ${
                location.pathname === link.href
                  ? transparent ? "text-[#a8d5b5] bg-white/10" : "text-[#1a3d2b] bg-[#f0ece4]"
                  : transparent ? "text-white/80 hover:text-white hover:bg-white/10" : "text-stone-600 hover:text-[#1a3d2b] hover:bg-[#f7f4ef]"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* Desktop CTA */}
        <div className="hidden md:flex items-center gap-2">
          <a
            href="https://wa.me/905362771709"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className={`flex items-center gap-1.5 text-sm font-semibold px-3 py-2 rounded-lg transition-all cursor-pointer whitespace-nowrap ${transparent ? "text-green-300 hover:bg-white/10" : "text-green-700 hover:bg-green-50"}`}
          >
            <Icon name="ri-whatsapp-line" className="text-base" />
            WhatsApp
          </a>
          <a
            href="tel:+905362771709"
            className="flex items-center gap-2 bg-[#1a3d2b] hover:bg-[#14301f] text-[#a8d5b5] text-sm font-bold px-5 py-2.5 rounded-full transition-all cursor-pointer whitespace-nowrap"
          >
            <Icon name="ri-phone-fill" className="text-sm" />
            Hemen Ara
          </a>
        </div>

        {/* Mobile Hamburger */}
        <button
          className={`md:hidden w-9 h-9 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${transparent ? "text-white" : "text-[#1a3d2b]"}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menüyü aç"
        >
          <Icon name={menuOpen ? "ri-close-line" : "ri-menu-3-line"} className="text-xl" />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-stone-100">
          <nav className="flex flex-col py-2">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-6 py-3 text-sm font-medium transition-colors ${location.pathname === link.href ? "text-[#1a3d2b] bg-[#f0ece4]" : "text-stone-700 hover:text-[#1a3d2b] hover:bg-[#f7f4ef]"}`}
              >
                {link.label}
              </Link>
            ))}
            <div className="px-4 py-3 flex gap-2">
              <a href="tel:+905362771709" className="flex-1 flex items-center justify-center gap-2 bg-[#1a3d2b] text-[#a8d5b5] text-sm font-bold py-3 rounded-full cursor-pointer whitespace-nowrap">
                <Icon name="ri-phone-fill" /> Ara
              </a>
              <a href="https://wa.me/905362771709" target="_blank" rel="nofollow noopener noreferrer" className="flex-1 flex items-center justify-center gap-2 bg-green-600 text-white text-sm font-bold py-3 rounded-full cursor-pointer whitespace-nowrap">
                <Icon name="ri-whatsapp-fill" /> WhatsApp
              </a>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}
